import api from '@/services/api';
import store from '@/vuex/store';
import mock from '../../../static/support/sample-data/usuarioLogado';
import Funcionario from '../../domain/funcionario';
import registraUsuarioLogado from './registraUsuarioLogado';
import ErrorHelper from '@/helpers/ErrorHelper';

const perfisFuncionarioPermitidos =
  ['CARGO_LIVRE_PROVIMENTO',
  'QUADRO_PERMANENTE',
  'CELETISTA_ESTAVEL',
  'CELETISTA_TEMPORARIO',
  'EX_CSTC',
  'MUNICIPALIZADO',
  'CARGO_ELETIVO',
  'CAPEP_CEDIDOS',
  'CONSELHEIRO_TUTELAR'];

const listaFuncionariosLogados = async vm => {
  const usuarioLogado = store.state.usuarioLogado;

  try {
    const autenticado = await api.get('pessoas-fisicas/autenticada');
    const funcionarios = autenticado.funcionarios;

    if (!funcionarios.length) bloqueiaUsuarioInvalido(vm);

    const funcionariosAtivos = funcionarios.filter(
      item =>
        item.dataFimAtividade === null &&
        item.dataInicioAtividade !== null &&
        item.lotacao !== null &&
        perfisFuncionarioPermitidos.includes(item.tipo.nome),
    );
    if (!funcionariosAtivos.length) bloqueiaUsuarioInvalido(vm);

    const funcionariosOrdenados = funcionariosAtivos.sort((a, b) => {
      if (a.dataInicioAtividade > b.dataInicioAtividade) return -1;
      if (a.dataInicioAtividade < b.dataInicioAtividade) return 1;
    });

    const funcionariosMapeados = mapeiaFuncionarios(funcionariosOrdenados);
    const logado = mapeiaLogado(
      autenticado,
      usuarioLogado,
      funcionariosMapeados,
    );

    // registraUsuarioLogado(mock);
    registraUsuarioLogado(logado);
  } catch (error) {
    error => {
      const mensagem = ErrorHelper.trataMensagem(error);
      vm.$root.$refs.toastr.e(mensagem, 'Atenção');
    };
  }
};

const bloqueiaUsuarioInvalido = vm => {
  vm.$root.$refs.toastr.removeByType('success');
  vm.$root.$data.isAuthenticated = false;
  store.commit('setToken', '');
  vm.$router.push({ name: 'SemAcesso' });
};

const mapeiaFuncionarios = funcionarios => {
  const mapeados = funcionarios.map(item => {
    if (item.lotacao && item.tipo) {
      const funcionario = new Funcionario(
        item.id,
        item.cargoPrincipal,
        item.lotacao.sigla,
        item.lotacao.nome,
        item.dataInicioAtividade,
        item.dataFimAtividade,
        item.tipo.nome,
        item.lotacao.codigoCentroCustoFormatado,
        item.registroFormatado,
        item.lotacao.id,
        item.false,
      );

      return funcionario;
    }
  });

  return mapeados;
};

const mapeiaLogado = (autenticadoApi, usuario, funcionarios) => {
  usuario.idPessoa = autenticadoApi.id;
  usuario.cpf = autenticadoApi.cpf;
  usuario.funcionarios = [...funcionarios];

  return usuario;
};

export default listaFuncionariosLogados;



// WEBPACK FOOTER //
// ./src/pages/home/listaFuncionariosLogados.js